var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TrayArrowDown } from 'mdi-material-ui';
import { IconButton } from '@mui/material';
import Popper from '../Popper';
import DownloadPopper from '../DownloadPopper';
function DownloadIconButton(_a) {
    var { file, files } = _a, props = __rest(_a, ["file", "files"]);
    return (_jsx(Popper, Object.assign({ content: _jsx(DownloadPopper, { file: file }) }, { children: _jsx(IconButton, Object.assign({ "aria-label": "download" }, props, { sx: { color: '#505F79' } }, { children: _jsx(TrayArrowDown, { fontSize: 'inherit' }) })) })));
}
export default DownloadIconButton;
